import { createSlice } from "@reduxjs/toolkit";
import { getCustomerById,getCustomerList } from "./ThunkActions";
import { iCustomerState, REDUCER_NAME } from "./Types"; 

// Define initial state based on the provided structure
const initialState: iCustomerState = {
  isLoading: false,
  customerList: [], 
  errorMessage: null,
  customerDetails: null,
  pagination: null,
};
export const customerSlice = createSlice({
  name: REDUCER_NAME, 
  initialState,
  reducers: {
    resetCustomerState: () => {
      return initialState; 
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerById.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCustomerById.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.customerDetails = payload.data.customer; 
          state.isLoading = false;
        }
      })
      .addCase(getCustomerById.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch invoice data";
        state.isLoading = false;
      })
      .addCase(getCustomerList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCustomerList.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.customerList = payload.data.data;
          state.pagination = payload.data.pagination ?? null;
          state.isLoading = false;
        }
      })
      .addCase(getCustomerList.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch customer data";
        state.isLoading = false;
      });
  },
});

export const { resetCustomerState } = customerSlice.actions;
export default customerSlice.reducer;
